import { InjectionKey } from "vue";
import { DateTime } from "luxon";

// ReSharper disable InconsistentNaming

export class CalendarAppParamType {
  parkCmsKeys: string[] = null!;
  monthlyLeadIn: string = null!;
  dailyLeadIn: string = null!;
  featuredEventsHeadline: string = null!;
  allActivitiesHeadline: string = null!;
  moreDetailsCTA: string = null!;
  purchaseCTAName: string = null!;
  purchaseCTAUrl: string = null!;
  listByActivity = false;
  timeZoneName = 'America/New_York'; // Default the property time zone to US Eastern
  localInPropertyTz = true;

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  constructor(dto: any) {
    Object.assign(this, dto);

    const dtLocal = DateTime.local();
    this.localInPropertyTz = dtLocal.offset === dtLocal.setZone(this.timeZoneName).offset;
  }
}


const CalendarAppParam: InjectionKey<CalendarAppParamType> = Symbol();
export default CalendarAppParam;

// ReSharper restore InconsistentNaming
